import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/app';
import initI18n from './i18n';

export function initialize(element: HTMLElement, language: string, pid?: string) {
    initI18n(language);

    console.log('language', language);
    console.log('pid', pid);

    const root = ReactDOM.createRoot(element);

    root.render(
        <React.StrictMode>
            <App language={language} pid={pid} />
        </React.StrictMode>
    );
}